export const amountFormat = (amount: number) => (+(amount || 0)).toLocaleString(undefined, {style: 'currency', currency: 'PHP'})
